export const initialState = () => ({
  loading: {
    show: false,
    message: ""
  },
  flow: null,
  skipCredit: false,
  skipCoverage: false,
  skipBiometry: false,
  isEditing: false,
  isComingFromSchedule: false,
  saleToEditId: "",
  selectedOfferId: "",
  origin: "",
  saleId: null,
  saleCode: "",
  saleDate: "",
  saleHistory: [],
  saleSeller: {},
  coverageStatus: null,
  uuid: "",
  status: "",
  subStatus: "",
  saleItemUuid: "",
  qrcode: "",
  fromVisit: null,
  rules: {
    shouldBypassCoverage: false
  },
  dataToTransform: {},
  note: "",
  selectedRoutes: {},
  providerSaleFlows: [],
  selectedProviderSaleFlow: {},
  deactivatedEditFlowToUse: {},
  hasCaptation: false,
  hasCtos: false,
  canMovePin: false,
  hasToChangeFlowByRole: false,
  personType: [],
  bePeopleSearch: false,
  allowAddResponsible: false,
  onlyQualifiedResponsibles: false,
  blockDuplicatedCustomerContacts: false
})
